import { ExportButton } from "@/components/commons/export-button"
import { ENDPOINTS } from "@/constants"
import { useDownloadCSV, useScheduleSearchParams } from "@/hooks"
export const ScheduleDownload = () => {
  const { params } = useScheduleSearchParams()
  const endpoint = ENDPOINTS.RECEIVABLE_INSTALLMENTS_DOWNLOAD
  const fileName = `recebiveis_${new Date().getTime()}.csv`
  const newParams = { date: params.date }
  const { handleDownload, isDownloading } = useDownloadCSV({
    endpoint,
    fileName,
    params: newParams as DownloadCSVParamsType,
  })
  return <ExportButton onClick={handleDownload} disabled={isDownloading} />
}
